import Vue from 'vue';
import axios from 'axios';
import API from '../api';
import { ITEM_TYPES } from '@/config/constants'

export const ItemsModule = {
  state: {
    items: [],
    isRequestingItems: false,
    errored: false,
    error: ''
  },

  actions: {
    getItems({ commit }) {
      commit('getItemsRequest');
      return axios
        .get(`${API.BASE_URL}${API.ITEMS}`, API.RequestHeaders())
        .then(response => {
          if (response.status === 200) {
            commit('getItemsSuccess', response.data);
            return response.data.original
          }
        })
        .catch(error => {
          commit('getItemsError', error);
        });
    },

    createItem({ commit }, itemData) {
      commit('createItemsRequest');
      return axios
        .post(`${API.BASE_URL}${API.ITEMS}`, itemData, API.RequestHeaders())
        .then(response => {
          if (response.status === 201) {
            commit('createItemsSuccess', response.data.original);
            return response.data.original
          }
        })
        .catch(error => {
          commit('createItemsError', error);
        });
    },

    updateItem({ commit }, itemData) {
      const itemId = itemData.id;
      delete itemData.id;

      commit('updateItemsRequest');
      return axios
        .put(`${API.BASE_URL}${API.ITEMS}/${itemId}`, itemData, API.RequestHeaders())
        .then(response => {
          if (response.status === 200) {
            commit('updateItemsSuccess', response.data.original);
            return response.data.original
          }
        })
        .catch(error => {
          commit('updateItemsError', error);
        });
    },

    removeItem({ commit }, itemId) {
      return new Promise((resolve, reject) => {
        return axios
        .delete(`${API.BASE_URL}${API.ITEMS}/${itemId}`, API.RequestHeaders())
        .then(response => {
          if (response.status === 200) {
            commit('deleteItemsSuccess', itemId);
            resolve(response.data.original)
          }
        })
        .catch(error => {
          commit('deleteItemsError', error);
          reject(error)
        });
      })
    }
  },

  mutations: {
    getItemsRequest(state) {
      state.isRequestingItems = true;
    },

    getItemsSuccess(state, payload) {
      state.items = payload;
      state.isRequestingItems = false;
    },

    getItemsError(state, error) {
      state.isRequestingItems = false;
      state.errored = true;
      state.error = error.message;
    },

    createItemsRequest(state) {
      state.isRequestingItems = true;
    },

    createItemsSuccess(state, payload) {
      state.items.push(payload);
      state.isRequestingItems = false;
    },

    createItemsError(state, error) {
      state.isRequestingItems = false;
      state.errored = true;
      state.error = error.message;
    },

    deleteItemsSuccess(state, itemId) {
      // find the removed object
      const removedObject = state.items.find(
        item => item.id === itemId
      );
      // find the index of the remove object in contacts array
      const removedObjectIndex = state.items.indexOf(removedObject);

      // remove the object from state
      state.items.splice(removedObjectIndex, 1);
    },

    deleteItemsError(state, error) {
      state.errored = true;
      state.error = error.message;
    },

    updateItemsRequest(state) {
      state.isRequestingItems = true;
    },

    updateItemsSuccess(state, payload) {
      const itemIndex = state.items.map(item => item.id).indexOf(payload.id);
      Vue.set(state.items, itemIndex, {...state.items[itemIndex], ...payload})

      state.isRequestingItems = false;
    },

    updateItemsError(state, error) {
      state.isRequestingItems = false;
      state.errored = true;
      state.error = error.message;
    }
  },

  getters: {
    getAvailableItems(state) {
      return state.items;
    },

    getAvailableItemsUnclassified(state) {
      return state.items.filter(item => item.category_id === ITEM_TYPES.UNCLASSIFIED);
    },

    getAvailableItemsAccomodations(state) {
      return state.items.filter(item => item.category_id === ITEM_TYPES.ACCOMMODATIONS);
    }
  }
};
